import { useCallback, useState } from 'react';
import { analyticsTrackEvent } from '../../../core/analytics';
import { Events } from '../../Account/util/analytics';
import { isIosSafariOnly } from '../../../core/util/device';
import { campaignNames, DOWNLOAD_DRIVER_IMPRESSION } from '../../../core/analytics/events';

export default () => {
  const [open, setOpen] = useState(false);

  const handleCloseDrawer = useCallback(() => {
    analyticsTrackEvent(Events.CLOSE_DRAWER);
    setOpen(false);
  }, [setOpen]);

  const handleOpenDrawer = useCallback(() => {
    analyticsTrackEvent(Events.OPEN_DRAWER);
    setOpen(true);

    if (isIosSafariOnly()) {
      analyticsTrackEvent(DOWNLOAD_DRIVER_IMPRESSION, {
        campaignName: campaignNames.ACCOUNT_DRAWER,
      });
    }
  }, [setOpen]);

  return { open, handleCloseDrawer, handleOpenDrawer };
};
